<template>
  <div class="con-details">
    <div class="consult-content">
      <div class="cont-box">
        <div class="box-title">咨询类型</div>
        <div class="box-value">{{changeData(formData.dataType)}}</div>
        <div class="box-time">咨询时间：{{formData.createTime}}</div>
      </div>
      <div class="cont-box">
        <div class="box-title">咨询内容</div>
        <div class="box-value box-value2">{{formData.content}}</div>
      </div>
      <div class="cont-box">
        <div class="box-title">上传图片</div>
        <div class="box-value box-value3">
          <img @click.prevent="checkImg" :src="formData.cusImg" alt />
        </div>
      </div>
      <van-image-preview v-model="show" :images="images" />
      <div class="box-reply">
        <div class="cont-box">
          <div class="box-title reply-title">管理员回复</div>
          <div class="box-time">回复时间：{{formData.updateTime}}</div>
        </div>
        <div class="cont-box">
          <div class="box-title">回复内容</div>
          <div class="box-value box-value2">{{formData.replyContent}}</div>
        </div>
        <div class="cont-box">
          <div class="box-title">上传图片</div>
          <div class="box-value box-value3">
            <img @click.prevent="checkreplyImg" :src="formData.replyImg" alt />
          </div>
        </div>
        <van-image-preview :closeable=true v-model="replyImg" :images="replyImgs" />
      </div>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
export default {
  data() {
    return {
      value: 'yonghu',
      value1: 'yonghu',
      show: false,//上传图片预览
      replyImg:false,//回复图片预览
      images: [],
      replyImgs:[],
      formData:{}
    }
  },
  mounted(){
    this.getData()
  },
  methods: {
    getData(){
      let that=this
      let data={
        id:this.$route.query.id
      }
      that.$fetchGet(URLTB.communicationDetail.url, data).then(res=>{
        if(res.data.code==20000){
          that.formData=res.data.data
          that.images.push(that.formData.cusImg)
          if(that.formData.replyImg){
            that.replyImgs.push(that.formData.replyImg)
          }
        }
      })
    },
    // 改变数据状态
    changeData(i) {
      let dataType = null
      switch (i) {
        case 3:
          dataType = '贷款业务'
          break;
        case 4:
          dataType = '保险业务'
          break;
        case 5:
          dataType = '操作使用'
          break;
        case 6:
          dataType = '其他'
          break;
        default:
          break;
      }
      return dataType
    },
    checkImg() {//图片预览
      this.show = true
    },
    checkreplyImg(){
      this.replyImg=true
    }
  }
}
</script>

<style lang="less" scoped>
.con-details {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  font-size: 12px;
  color: #333333;
  .consult-content {
    width: 355px;
    margin: auto;
    .cont-box {
      display: flex;
      position: relative;
      margin-top: 13px;
      padding: 0 13px;
      .box-title {
        font-weight: 500;
      }
      .box-value {
        margin-left: 25px;
        font-weight: 400;
      }
      .box-value2 {
        width: 230px;
      }
      .box-value3 {
        width: 93px;
        height: 70px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .box-time {
        position: absolute;
        // top: 13px;
        right: 15px;
        font-size: 10px;
        color: #999999;
      }
    }
    .box-reply {
      width: 355px;
      height: 160px;
      margin: 15px auto auto;
      padding: 13px 0;
      background: #fffdfa;
      .reply-title {
        color: #fc6e09;
      }
    }
  }
}
</style>